import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=0d8a9b8c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8a9b8c')) {
      api.createRecord('0d8a9b8c', component.options)
    } else {
      api.reload('0d8a9b8c', component.options)
    }
    module.hot.accept("./StartPage.vue?vue&type=template&id=0d8a9b8c&", function () {
      api.rerender('0d8a9b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/start-page/StartPage.vue"
export default component.exports